var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 266,
    viewBox: "0 0 585 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.809 259H102.441V203.824H0.438V159.538L95.181 3.44798H151.809V164.257H180.849V203.824H151.809V259ZM37.827 164.257H102.441V53.179L37.827 164.257ZM361.501 34.666C374.569 57.898 381.466 90.568 381.466 133.039C381.466 175.51 374.569 208.18 361.501 231.049C348.433 253.918 325.564 265.534 292.531 265.534C259.861 265.534 236.992 253.918 223.924 231.049C210.493 208.18 203.959 175.51 203.959 133.039C203.959 90.568 210.493 57.898 223.924 34.666C236.992 11.797 259.861 0.180979 292.531 0.180979C325.564 0.180979 348.433 11.797 361.501 34.666ZM262.765 200.557C267.847 216.529 277.648 224.152 292.531 224.152C307.777 224.152 317.578 216.529 322.297 200.557C327.016 184.948 329.194 162.442 329.194 133.039C329.194 101.821 327.016 78.952 322.297 64.069C317.578 49.186 307.777 41.926 292.531 41.926C277.648 41.926 267.847 49.186 262.765 64.069C258.046 78.952 255.505 101.821 255.505 133.039C255.505 162.442 258.046 184.948 262.765 200.557ZM555.221 259H505.853V203.824H403.85V159.538L498.593 3.44798H555.221V164.257H584.261V203.824H555.221V259ZM441.239 164.257H505.853V53.179L441.239 164.257Z",
    fill: "url(#paint0_linear_1_600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_600",
    x1: 294,
    y1: 53.5,
    x2: 294,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40445D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.fc3fca925701c6ad9b5edbf7f6c917da.svg";
export { ForwardRef as ReactComponent };